import React from 'react';
import store from 'config/store/';
import { removeToken } from 'actions/tokenAction';

import bodyScrollLock from 'services/bodyScrollLock'

export default function DeleteCookieLink() {
  const handleRemoveCookie = (event) => {
    event.preventDefault();
    store.dispatch(removeToken());
    const modal = document.querySelector('#modal-popup-wrong-email-sent');

    window.finanztip.clearScrollLocks();
    modal.classList.remove('active');
    bodyScrollLock.enableScroll();

    cleanFormOverlayStateClasses()
  };

  const cleanFormOverlayStateClasses = () => {
    const overlay = document.getElementById('modal-popup-newsletter-overlay');

    if(overlay) {
      setTimeout( () => {
        overlay.classList.remove('state-soi', 'state-doi', 'state-new');
      }, 50)
    }

  }

  return (
    <span
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
      className="permalink semibold"
      onClick={handleRemoveCookie}
    >
      Link
    </span>
  );
}
